import Layout from './components/layout';
import Details from './components/details';
import FocusModeDetails from './components/focusModeDetails';

export default {
	Layout,
	Details,
	FocusModeDetails
}